module.exports = __webpack_public_path__ + "static/media/registraduria-nacional-seeklogo.eea7373f.png";